import React from 'react'
import Button from '../Button'

import { Container, Content, Backdrop } from './styles'

interface Props {
  position?: 'top-right' | 'bottom-left'
  open: boolean
  onChange: (open: boolean) => void
  button: Omit<React.ComponentProps<typeof Button>, 'onClick'>
}

const Popover: React.FC<Props> = ({ open, button, onChange, position = 'bottom-left', children }) => (
  <Container>
    <Button
      {...button}
      onClick={() => onChange(!open)}
    />

    <Content
      open={open}
      position={position}
    >
      {children}
    </Content>

    {open && (
      <Backdrop
        onClick={() => onChange(!open)}
      />
    )}
  </Container>
)

export default Popover
